import { PreceptLevel, PreceptCategory } from '@/types'

/**
 * 节气戒期配置
 */
export const SOLAR_TERM_CONFIG: Record<string, { reason: string; punishment: string; level: PreceptLevel }> = {
  '春分': {
    reason: '二分日',
    punishment: '犯者生子五官四肢不全，父母有灾',
    level: PreceptLevel.MAJOR
  },
  '秋分': {
    reason: '二分日',
    punishment: '犯者必得危疾',
    level: PreceptLevel.MAJOR
  },
  '夏至': {
    reason: '二至日',
    punishment: '犯者必得急疾',
    level: PreceptLevel.MAJOR
  },
  '冬至': {
    reason: '二至日',
    punishment: '犯者必得急疾',
    level: PreceptLevel.MAJOR
  },
  '立春': {
    reason: '四立日',
    punishment: '犯之减寿五年',
    level: PreceptLevel.MAJOR
  },
  '立夏': {
    reason: '四立日',
    punishment: '犯之减寿五年',
    level: PreceptLevel.MAJOR
  },
  '立秋': {
    reason: '四立日',
    punishment: '犯之减寿五年',
    level: PreceptLevel.MAJOR
  },
  '立冬': {
    reason: '四立日',
    punishment: '犯之减寿五年',
    level: PreceptLevel.MAJOR
  }
}

/**
 * 阳错日配置：每月对应的干支
 */
export const YANG_CUO_CONFIG: Record<number, string> = {
  1: '甲寅',  // 正月
  2: '乙卯',  // 二月
  3: '甲辰',  // 三月
  4: '丁巳',  // 四月
  5: '丙午',  // 五月
  6: '丁未',  // 六月
  7: '庚申',  // 七月
  8: '辛酉',  // 八月
  9: '庚戌',  // 九月
  10: '癸亥', // 十月
  11: '壬子', // 十一月
  12: '癸丑'  // 十二月
}

/**
 * 阴错日配置：每月对应的干支
 */
export const YIN_CUO_CONFIG: Record<number, string> = {
  1: '庚戌',  // 正月
  2: '辛酉',  // 二月
  3: '庚申',  // 三月
  4: '丁未',  // 四月
  5: '丙午',  // 五月
  6: '丁巳',  // 六月
  7: '甲辰',  // 七月
  8: '乙卯',  // 八月
  9: '甲寅',  // 九月
  10: '癸丑', // 十月
  11: '壬子', // 十一月
  12: '癸亥'  // 十二月
}

/**
 * 节气解释说明
 */
export const SOLAR_TERM_EXPLANATIONS: Record<string, string> = {
  '春分': '春分日雷将发声，天地阴阳二气开始激烈交战，此日犯戒会影响后代健康，给父母带来灾祸。宜从惊蛰节禁起，戒过一月',
  '秋分': '秋分日杀气浸盛，阳气逐渐衰退，阴气渐长，此日犯戒会严重损害身体健康。宜从白露节禁起，戒过一月',
  '夏至': '夏至日阴阳相争，是死生分判的关键时刻，此日犯戒会招致急重疾病。宜从芒种节禁起，戒过一月',
  '冬至': '冬至日阴阳相争，是死生分判的关键时刻，此日犯戒会招致急重疾病。冬至半夜子时犯之，并冬至后庚辛日，及第三戌日犯之，皆主在一年内亡。宜从大雪节禁起，戒过一月',
  '立春': '立春是二十四节气之首，春季的开始，天地阳气初生，万物复苏。此日犯戒会严重影响寿命，减寿五年',
  '立夏': '立夏是夏季的开始，天地阳气旺盛，万物生长茂盛。此日犯戒会严重影响寿命，减寿五年',
  '立秋': '立秋是秋季的开始，天地阳气渐收，阴气渐长。此日犯戒会严重影响寿命，减寿五年',
  '立冬': '立冬是冬季的开始，天地阳气潜藏，阴气盛极。此日犯戒会严重影响寿命，减寿五年'
}

/**
 * 节气修行建议
 */
export const SOLAR_TERM_SUGGESTIONS: Record<string, string> = {
  '春分': '春分前应从惊蛰节开始禁戒，持戒一个月，可诵经礼佛，修身养性，避免雷震之灾',
  '秋分': '秋分前应从白露节开始禁戒，持戒一个月，可诵经礼佛，收敛心神，顺应天时',
  '夏至': '夏至今应从芒种节开始禁戒，持戒一个月，可静坐养心，避免阴阳失调',
  '冬至': '冬至今应从大雪节开始禁戒，持戒一个月，可静坐养心，潜藏阳气',
  '立春': '立春是二十四节气之首，春季的开始，犯之减寿五年，应严格持戒',
  '立夏': '立夏是夏季的开始，犯之减寿五年，应严格持戒',
  '立秋': '立秋是秋季的开始，犯之减寿五年，应严格持戒',
  '立冬': '立冬是冬季的开始，犯之减寿五年，应严格持戒'
}

/**
 * 通用解释说明映射
 */
export const EXPLANATION_MAP: Record<string, string> = {
  '释迦如来成道日': '农历腊月初八是释迦牟尼佛在菩提树下夜睹明星、悟道成佛的殊胜日子。此日是佛教最重要的纪念日之一，佛陀在此日证得无上正等正觉，开启了佛法在人间的传播。此日功德殊胜，持戒修行可获无量福报',
  '四天王巡行': '四天王巡行日是每月初八、十四、十五、廿三、廿九、三十日。四天王（东方持国天王、南方增长天王、西方广目天王、北方多闻天王）于此六日巡视人间，考察善恶，记录功过。此日宜持戒清净、行善积德',
  '斗降': '斗星君下降之日，监察世人行为',
  '雷斋日': '雷斋日是每月初六日，为道教斋戒祭祀雷祖（九天应元雷声普化天尊）之日。雷祖巡视考察人类善恶，主持正义、惩恶扬善。此日宜斋戒清净、行善积福，犯戒者减寿',
  '月望': '月圆之日，阴阳交泰，宜清净持戒',
  '月朔': '新月之日，月神诞辰，宜持戒祈福',
  '三元降': '三元（天、地、水）之神下降，校世人善恶',
  '天地仓开日': '天地仓开日是天仓、地仓开启之日，此日天地之气交流，仓廪开放，是吉庆之日，犯戒会损伤寿命',
  '天仓开日': '天仓开日是天仓开启之日，此日天地之气交流，仓廪开放，是吉庆之日，犯戒会损伤寿命',
  '人神在阴': '先祖神灵在阴间之日，犯戒易得疾病，宜先一日即戒',
  '司命奏事': '司命之神向天庭奏报世人善恶',
  '杨公忌': '唐代风水宗师杨筠松所订定的忌日，诸事不宜',
  '五虚忌': '五虚指脉细、皮寒、气少、泄利前后、饮食不入等五种虚弱状态，此日犯戒易损伤身体',
  '六耗忌': '六耗指阴、阳、晦、明、风、雨所导致的六种疾病，此日犯戒易致病',
  '九毒日': '九毒日天地之气不正，湿热毒气盛行，犯戒易遭奇祸不测',
  '天地交泰': '天地阴阳交合之日，犯戒可能导致严重后果',
  '阴毒日': '阴毒大忌之日，邪气最盛，犯戒有大凶险',
  '三辛日': '三辛日是每月天干为辛的日子。传统认为辛日为雷祖（九天应元雷声普化天尊）监观万天、亲察人间之日，此日雷祖巡视世间善恶，犯戒会损害寿命'
}

/**
 * 中文月份映射
 */
export const CHINESE_MONTHS = ['', '正', '二', '三', '四', '五', '六', '七', '八', '九', '十', '冬', '腊']

/**
 * 十斋日
 */
export const TEN_PRECEPT_DAYS = [1, 8, 14, 15, 18, 23, 24, 28, 29, 30]

/**
 * 戒期等级文本映射
 */
export const LEVEL_TEXT: Record<PreceptLevel, string> = {
  [PreceptLevel.MAJOR]: '大戒',
  [PreceptLevel.MODERATE]: '中戒',
  [PreceptLevel.MINOR]: '宜戒',
  [PreceptLevel.SAFE]: '安全'
}

/**
 * 获取戒期等级文本
 */
export function getPreceptLevelText(level: PreceptLevel): string {
  return LEVEL_TEXT[level]
}

/**
 * 基础修行建议
 */
export const BASE_SUGGESTIONS: Record<PreceptLevel, string> = {
  [PreceptLevel.MAJOR]: '大戒之日，应严格持戒，可诵经礼忏，广修善业，以求消灾祈福',
  [PreceptLevel.MODERATE]: '中戒之日，应谨慎持戒，避免不当行为，可修善积德',
  [PreceptLevel.MINOR]: '宜戒之日，应基本持戒，保持身心清净',
  [PreceptLevel.SAFE]: '平安之日，可正常修行，保持正念'
}
